var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEditorTextSize = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { id: "Gruppe_1085_1_", transform: "translate(-255.169 -652.298)" },
                React.createElement("line", { x1: "259.5", y1: "668.3", x2: "267.5", y2: "668.3" }),
                React.createElement("line", { x1: "263.5", y1: "669.2", x2: "263.5", y2: "676.2" })),
            React.createElement("g", { id: "Gruppe_1086_1_", transform: "translate(-254.169 -651.25)" },
                React.createElement("line", { strokeWidth: "2.5", x1: "265.8", y1: "657.3", x2: "279.8", y2: "657.3" }),
                React.createElement("line", { strokeWidth: "2.5", x1: "272.8", y1: "658.8", x2: "272.8", y2: "670.8" })))));
});
export default IconEditorTextSize;
//# sourceMappingURL=IconEditorTextSize.js.map